import _ from 'lodash';
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import BarChartComponent from '../../../../core/components/charts/bar-chart';

import {
  CHART_HEIGHT,
  Container,
  ChartContainer,
  Icon,
  Spacer,
} from './styles';

const INTERVAL = 20;
const BAR_STEP_SIZE = 5;
const ICON_SIZE = 'large';
const ICON_LEFT_NAME = 'chevron circle left';
const ICON_RIGHT_NAME = 'chevron circle right';

const BarChart = (props) => {
  const {
    tagAnalytics,
    onSelectedTag,
    selectedTags,
  } = props;

  const [activeStep, setActiveStep] = useState(0);
  const [bars, setBars] = useState([]);

  const steps = useMemo(() => (tagAnalytics.length ? _.ceil(tagAnalytics.length / INTERVAL) : 0), [tagAnalytics]);

  useEffect(() => {
    setActiveStep(0);
    setBars([]);
  }, [selectedTags]);

  useEffect(() => {
    if (_.isEmpty(tagAnalytics)) {
      setActiveStep(0);
      setBars([]);
    }

    if (!_.isEmpty(tagAnalytics) && activeStep === 0) {
      const initialBars = _.take(tagAnalytics, INTERVAL);
      setBars(initialBars);
    }
  }, [activeStep, tagAnalytics]);

  const handleNext = () => {
    const newStep = activeStep + 1;

    if (newStep < steps) {
      const indexOfLast = _.indexOf(tagAnalytics, _.last(bars)) + 1;
      const nextBars = _.slice(tagAnalytics, indexOfLast, indexOfLast + INTERVAL);

      setActiveStep(newStep);
      setBars(nextBars);
    }
  };

  const handlePrevious = () => {
    if (activeStep > 0) {
      const indexOfFirst = _.indexOf(tagAnalytics, _.first(bars));
      const prevBars = _.slice(tagAnalytics, indexOfFirst - INTERVAL, indexOfFirst);

      setActiveStep(activeStep - 1);
      setBars(prevBars);
    }
  };

  const handleClickBar = (value) => {
    const { id: tagAnalyticId } = value;
    const tag = _.find(tagAnalytics, { id: tagAnalyticId });

    onSelectedTag(tag);
  };

  const setBarChartData = () => ({
    labels: _.map(bars, (x) => _.capitalize(x.tag.name)),
    ids: _.map(bars, 'id'),
    datasets: [{
      hidden: false,
      backgroundColor: _.map(bars, 'tag.tagGroup.color'),
      data: _.map(bars, 'totalPeriod'),
    }],
  });

  const barChartData = setBarChartData();

  return (
    <Container>
      {!_.isEmpty(tagAnalytics) && activeStep > 0 && (
        <Icon
          size={ICON_SIZE}
          name={ICON_LEFT_NAME}
          onClick={handlePrevious}
        />
      )}
      <Spacer />
      {!_.isEmpty(tagAnalytics) && activeStep + 1 < steps && (
        <Icon
          size={ICON_SIZE}
          name={ICON_RIGHT_NAME}
          onClick={handleNext}
        />
      )}

      <ChartContainer>
        <BarChartComponent
          data={barChartData}
          height={CHART_HEIGHT}
          onBarClicked={handleClickBar}
          stepSize={BAR_STEP_SIZE}
          type="vertical"
        />
      </ChartContainer>
    </Container>
  );
};

BarChart.propTypes = {
  tagAnalytics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      tag: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        tagGroup: PropTypes.shape({
          color: PropTypes.string,
        }),
      }),
    }),
  ).isRequired,
  onSelectedTag: PropTypes.func.isRequired,
  selectedTags: PropTypes.arrayOf(
    PropTypes.string,
  ),
};

BarChart.defaultProps = {
  selectedTags: [],
};

export default BarChart;
